import { http } from '@/app/lib/http/client'

// ─── Types ────────────────────────────────────────────────────────────────────

export interface Sucursal {
    id: number
    name: string
}

export interface SystemVersion {
    version: string
}



// ─── Service ──────────────────────────────────────────────────────────────────

export const layoutService = {
    async csrf() {
        const apiBase = import.meta.env.VITE_API_URL.replace(/\/api\/v1\/?$/, '')
        await http.get(`${apiBase}/sanctum/csrf-cookie`)
    },

    /**
     * Obtiene la lista de sucursales que tiene acceso el usuario actual.
     */
    async getMySucursales(): Promise<Sucursal[]> {
        const response = await http.get('/auth/my-sucursals')
        return response.data.data
    },

    async getSystemVersion(): Promise<SystemVersion> {
        const response = await http.get('/settings/system-version')
        return response.data.data
    },

    /**
     * Obtiene el estado de conexion del navegador para mostrar el indicador de "En línea" o "Sin conexión"
     */
    async getBrowserConnectionState(): Promise<boolean> {
        return navigator.onLine
    },

}
